/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const bankid = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1 3.667h3m-3 8.666h3m-3-3h3m8-5.667h3m-3 8.667h3m-3-6h3m-8.5 0h3m-3 3h3"
    />
  </svg>
)
export default bankid
